import { schema } from 'normalizr';

export const fileSchema = new schema.Entity('file');
